import "./Portfolio.css";
import IMG1 from "../../assets/portfolio1.jpg";
import IMG2 from "../../assets/portfolio2.jpg";
import IMG3 from "../../assets/portfolio3.jpg";
import IMG4 from "../../assets/portfolio4.jpg";
import IMG5 from "../../assets/portfolio5.jpg";
import IMG6 from "../../assets/portfolio6.jpg";
import IMG7 from "../../assets/portfolio7.png";
import IMG8 from "../../assets/portfolio8.png";
import IMG9 from "../../assets/portfolio9.jpg";
import IMG10 from "../../assets/portfolio10.jpg";
import IMG11 from "../../assets/portfolio11.png";
import IMG12 from "../../assets/portfolio12.png";
import IMG13 from "../../assets/portfolio13.png";
import IMG14 from "../../assets/portfolio14.png";
import IMG15 from "../../assets/portfolio15.png";
import IMG16 from "../../assets/portfolio16.png";
import IMG17 from "../../assets/portfolio17.png";
import { LazyLoadComponent, LazyLoadImage } from "react-lazy-load-image-component";


const datas = [{
  id: 8,
  image: IMG13,
  title: "PTGR Landing Page",
  github: "https://github.com/Akuna444",
  demo: "https://ptgr.ch",
  description: "The PTGR landing page features a bold mission-driven introduction, highlights curated products and services that promote innovation and growth, showcases core values like education and purposeful progress, and includes clear calls to action, community testimonials, and a subscription section — all designed to invite users into a shopping experience that puts impact before profit.",
  tags: ["Framermotion", "Nextjs", "Hook-Form", "Zod", "NodeJS", "ExpressJS", "PostgreSQL", "RTK Query"],
},
{
  id: 2,
  image: IMG11,
  title: "Fleet Management System ",
  github: "https://github.com/Akuna444",
  demo: "https://fleet-mvp.vercel.app",
  description: "A fleet management system  designed to track vehicles, maintenance, fuel expenses, and fleet performance. Key features include user authentication, vehicle real-time data management,  vehicle CRUD operations, maintenance scheduling, expense logging, vehicle reporting, and a responsive UI. The platform integrates with a map service for vehicle location tracking and provides notifications for upcoming maintenance with multilingual support. I develop this project with tight deadline with in 1 month. ",
  tags: [
    "ReactJS",
    "NodeJS",
    "ExpressJS",
    "Typescript",
    "Shadcn/ui",
    "SocketIO",
    "OSM",
    "AWS",
    "Tanstack Table",
    "Redux",
    "RTK Query",
    "i18n",
  ],
},
{
  id: 8,
  image: IMG16,
  title: "Hive888 Dashboard",
  github: "https://github.com/Akuna444",
  demo: "https://hub.hive888.org",
  description: "HIVE888 is an emerging interactive platform that brings together talent, enterprises, and institutions to collaborate within a trusted Web3 ecosystem. It is designed to enable meaningful partnerships, drive innovation.",
  tags: ["ReactJS", "NodeJS", "ExpressJS", "PostgreSQL", "RTK Query", "Shadcn/ui", "SocketIO", "AWS", "RTK Query", "i18n"],
},

{
  id: 8,
  image: IMG17,
  title: "Hive888 Landing Page",
  github: "https://github.com/Akuna444",
  demo: "https://hive888.org",
  description: "HIVE888 is an emerging interactive platform that brings together talent, enterprises, and institutions to collaborate within a trusted Web3 ecosystem. It is designed to enable meaningful partnerships, drive innovation.",
  tags: ["Framermotion", "Nextjs", "Hook-Form", "Zod", "NodeJS", "ExpressJS", "PostgreSQL", "RTK Query"],
},
{
  id: 8,
  image: IMG12,
  title: "PTGR Shop",
  github: "https://github.com/Akuna444",
  demo: "https://shop.ptgr.ch",
  description: "PTGR Shop is a purpose-driven marketplace where innovation meets intention. More than just an online store, it’s a curated hub for individuals and businesses who seek to grow, connect, and make a meaningful impact. Every product and service offered is handpicked for its potential to drive real-world progress — whether through education, advanced technology, or forward-thinking economic models.",
  tags: ["E-commerce", "ReactJS", "NodeJS", "ExpressJS", "PostgreSQL", "RTK Query"],
},
{
  id: 2,
  image: IMG1,
  title: "Yimaru AI LMS ",
  github: "https://github.com/Akuna444",
  demo: "https://yimaru-final-year.vercel.app/",
  description: "Yimaru is AI Supported Online Web based Learning Management System (LMS) personal project that primarily intended for Ethiopian Teachers and student to learn and teach with own languages, that support multilingual such as (English, Amharic, Afan Oromo) which allows teacher to create course and to sell course while student can purchase by paying online. But student experience is boosted with AI by locale language",
  tags: [
    "NextJS",
    "Typescript",
    "RadixUI",
    "Pinecone",
    "Langchain",
    "Chapa",
    "NeonTech",
    "Cohere",
    "Groq",
    "Zustand",
    "i18n",
    "React Query",
  ],
},
{
  id: 8,
  image: IMG14,
  title: "PTGR Dashboard",
  github: "https://github.com/Akuna444",
  demo: "https://dashboard.ptgr.io",
  description: "The PTGR Customer Area Dashboard is a secure and intuitive portal where users can manage their entire PTGR experience. It allows customers to purchase and access self-study courses, buy tokens for platform services, and view detailed transaction history in real-time. The dashboard also includes profile management, order tracking, and downloadable invoices, all within a responsive and user-friendly interface. Built with role-based access control and integrated support tools, it ensures a personalized, seamless, and engaging experience for every user.",
  tags: ["ReactJS", "NodeJS", "ExpressJS", "PostgreSQL", "RTK Query"],
},
{
  id: 8,
  image: IMG15,
  title: "PTGR Token Page",
  github: "https://github.com/Akuna444",
  demo: "https://ptgr.io",
  description: "The PTGR Token Landing Page is a dedicated interface where users can purchase tokens used across the PTGR platform and access comprehensive token-related information. It provides real-time insights into token balance, usage history, and purchase options, along with clear explanations of how tokens can be used for courses, services, or platform features. Designed with a clean, responsive layout, the page ensures a smooth and secure buying experience while educating users on the value and functionality of PTGR tokens.",
  tags: ["Framermotion", "Nextjs", "Zod", "NodeJS", "ExpressJS", "PostgreSQL", "RTK Query"],
},
{
  id: 8,
  image: IMG8,
  title: "BMY Medical ERP",
  github: "https://github.com/Akuna444",
  demo: "#",
  description: "BMY Medicals Technology ERP system focuses on the company all departments, stakeholders and users, which allow for finance department and Inventory section (finance and inventory module), sales and marketing department, diagnostic department (service module), Engineering department (maintenance module), radiation protection and quality assurance department, HR department (HR module) and the executive department (Administrator Module) of the company. ",
  tags: ["ERP", "ReactJS", "NodeJS", "ExpressJS", "PostgreSQL", "RTK Query"],
},
{
  id: 3,
  image: IMG6,
  title: "MereqTech Website",
  github: "https://github.com/Akuna444",
  demo: "https://mereq-tech.vercel.app/",
  description: "The Mereq Tech Landing Page is a professionally designed web platform that effectively showcases the company's identity and services. It features dynamic animations implemented using Framer Motion and GSAP, enhancing the user experience with smooth and engaging interactions. Additionally, the website integrates Strapi Headless CMS for seamless blog management, ensuring efficient content creation and updates.",
  tags: ["NextJS", "TailwindCSS", "Framermotion", "GSAP", "Strapi"],
},

{
  id: 7,
  image: IMG9,
  title: "Habesha Nets",
  github: "https://github.com/Akuna444",
  demo: "https://habeshanets.com/",
  description: "Habeshanets is platform that create income for professionals during their extra time and to help students make money in their free time by connecting them with the global Habeshacommunity through a user-friendly platform that offers a wide range of services. also strive to make it easy for people in need of services to find and connect with providers quickly.",
  tags: ["React", "NestJS", "Postgres", "Stripe", "RTK Query", "Tailwind"],
},

{
  id: 7,
  image: IMG7,
  title: "Besh Gebeya",
  github: "https://github.com/Akuna444",
  demo: "https://besh3.beshgebeya.com/",
  description: "Beshgebeya Multi-Vendor E-commerce Website for East Africa Trading House, a subsidiary of East Africa Holding Group. The website serve as a platform for multiple companies under East Africa Trading House, offering a wide range of products, including fresh/green produce (Besh Fresh) and FMCG items.",
  tags: ["Wordpress", "Woocommerce", "PHP", "WCFM", "Elementor"],
},
{
  id: 7,
  image: IMG10,
  title: "True Mark",
  github: "https://github.com/Akuna444",
  demo: "https://truemarkethio.com",
  description: "True Mark Document Accreditation is a platform dedicated to academic document accreditation, certification, internationalization, and licensing services. It features a landing page, as well as admin and user dashboards for efficient course and document management.",
  tags: ["ExpressJS", "React", "Nodejs", "Mongodb", "TailwindCSS"],
},
{
  id: 1,
  image: IMG5,
  title: "Studylink",
  github: "https://github.com/Akuna444/studylink/",
  demo: "https://studylink-web.onrender.com",
  description: "StudyLink is a social media website designed to facilitate the sharing of study materials among students from different universities and departments. The platform serves as a centralized hub  where students can connect, collaborate, and access a wide range of educational resources,  including books, worksheets, audio, video and exams",
  tags: ["ReactJS", "NodeJS", "ExpressJS", "MongoDB", "MaterialUI"],
},

{
  id: 4,
  image: IMG3,
  title: "Community",
  github: "https://app.kreo.so",
  demo: "https://drive.google.com/file/d/1yJWjCVIN_W3FOQIPsVRBfgwqA74GkFiQ/view?usp=drive_link",
  description: "Community is a social media platform that enhances content creation through AI-powered tools, offering features such as grammar correction, multilingual generations, image generation, and more. It provides users with advanced options to refine and elevate their content seamlessly.",
  tags: [
    "T3 Stack",
    "NextJS",
    "TailwindCSS",
    "Typescript",
    "Websocket",
    "AntDesign",
  ],
},
{
  id: 5,
  image: IMG4,
  title: "Music Festival Website",
  github: "https://github.com/Akuna444/tailwind-tw-mf-website",
  demo: "https://tailwind-tw-mf-website.vercel.app/",
  description: "The Music Festival Landing Page is a simple yet visually appealing webpage built entirely with Tailwind CSS. It offers a clean and responsive design, ensuring an engaging user experience across all devices.",
  tags: ["TailwindCSS", "Responsiveness"],
},

{
  id: 6,
  image: IMG2,
  title: "ConvexICT",
  github: "https://github.com/Akuna444",
  demo: "https://convexict.com",
  description: "Convex is a sportsbook website built using WordPress and designed with the Elementor editor. It provides a comprehensive overview of the platform, including sections on About, Solutions, Blog, and other essential information, ensuring a seamless and informative user experience.",
  tags: ["Wordpress", "Elementor"],
},
];

function Portfolio() {
  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>
      <div className="container portfolio__container">
        {datas.map((data) => (
          <article key={data.id} className="portfolio__item">
            <div>
              <div className="portfolio__item-img">
                <LazyLoadImage effect="blur" src={data.image} alt={data.image} />
              </div>
              <h3 className="portfolio__title">{data.title}</h3>
              <p>{data.description}</p>
            </div>
            <div>

              <div className="tags__container">
                {data.tags.map((tag) => {
                  return <div className="tag">{tag}</div>;
                })}
              </div>
              <div className="portfolio__item-cta">
                <a
                  href={data.github}
                  className="btn"
                  target="_blank"
                  rel="noreferrer"
                >
                  Github
                </a>
                <a
                  href={data.demo}
                  className="btn btn-primary"
                  target="_blank"
                  rel="noreferrer"
                >
                  Live Demo
                </a>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Portfolio;
